module.exports = __webpack_public_path__ + "static/media/photo-cpf.0dff9791.svg";